import { useContext } from 'react';
import { PractitionerControlsContext } from '../../components/PractionerControlsProvider';

export default function usePractitionerControlsContext() {
  const context = useContext(PractitionerControlsContext);
  if (!context) {
    throw new Error('usePractitionerControlsContext must be used within a ParticipantControlsProvider');
  }
  return context;
}
